import React, { useEffect, useState } from "react";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import "./Elements.css";
import "./Elements.css";
import { Typography } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import { Box, Button } from "@mui/material";
import toast from "react-hot-toast";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";

function Elements() {
  return <div></div>;
}

export function AButton({ children, startIcon, endIcon }) {
  AButton.propTypes = {
    children: PropTypes.any,
    startIcon: PropTypes.any,
    endIcon: PropTypes.any,
  };
  return (
    <Button startIcon={startIcon} endIcon={endIcon} className="Login-button">
      {children}
    </Button>
  );
}

export function AButtonFit({ children }) {
  AButtonFit.propTypes = {
    children: PropTypes.any.isRequired,
  };
  return (
    <Button
      variant="contained"
      size="large"
      sx={{
        width: "fit-content",
        color: "black",
        borderRadius: "15px",
        background: "none",
        "&:hover": {
          background: "none",
        },
      }}
    >
      {children}
    </Button>
  );
}

export function AButton2({ children, startIcon, endIcon, width, color }) {
  AButton2.propTypes = {
    children: PropTypes.any.isRequired,
    startIcon: PropTypes.any.isRequired,
    endIcon: PropTypes.any.isRequired,
    width: PropTypes.any.isRequired,
    color: PropTypes.any.isRequired,
  };
  return (
    <Button
      variant="contained"
      startIcon={startIcon}
      endIcon={endIcon}
      size="large"
      sx={{
        width: width ? width : "100%",
        border: "1px solid white",
        background: "var(--secondary-bg) !important",
        color: color ? color : "var(--text-primary) !important",
        "&:hover": {
          background: "none",
        },
      }}
    >
      {children}
    </Button>
  );
}

export function AButton3({ children, startIcon, endIcon, width }) {
  AButton3.propTypes = {
    children: PropTypes.any.isRequired,
    startIcon: PropTypes.any.isRequired,
    endIcon: PropTypes.any.isRequired,
    width: PropTypes.any.isRequired,
  };
  return (
    <Button
      variant="contained"
      startIcon={startIcon}
      endIcon={endIcon}
      size="large"
      sx={{
        width: width ? width : "100%",
        border: "1px solid white",
        background: "var(--primary-bg) !important",
        color: "var(--text-secondary) !important",
        "&:hover": {
          background: "none",
        },
      }}
    >
      {children}
    </Button>
  );
}

export function WaveButton({ children, startIcon, endIcon, width }) {
  WaveButton.propTypes = {
    children: PropTypes.any.isRequired,
    startIcon: PropTypes.any.isRequired,
    endIcon: PropTypes.any.isRequired,
    width: PropTypes.any.isRequired,
  };
  return (
    <Button
      variant="contained"
      startIcon={startIcon}
      endIcon={endIcon}
      size="large"
      sx={{
        width: width ? width : "100%",
      }}
      className="wave-animation"
    >
      {children}
    </Button>
  );
}

export function AHeading({ children, color }) {
  AHeading.propTypes = {
    children: PropTypes.any,
    color: PropTypes.any,
  };
  return (
    <Typography
      variant="h2"
      component="h1"
      gutterBottom
      sx={{ fontWeight: "700", color: color }}
    >
      {children}
    </Typography>
  );
}

export function CustomDateTimeField({
  label,
  name,
  placeholder,
  value,
  onChange,
  isRequired,
  fullWidth = true,
  size = "small",
  type = "date", // Allows switching between 'date' and 'datetime-local'
  ...props
}) {
  CustomDateTimeField.propTypes = {
    label: PropTypes.any,
    placeholder: PropTypes.any,
    name: PropTypes.any,
    value: PropTypes.any,
    isRequired: PropTypes.any,
    onChange: PropTypes.any,
    fullWidth: PropTypes.any,
    size: PropTypes.any,
    type: PropTypes.any,
  };
  return (
    <TextField
      label={label}
      name={name}
      placeholder={placeholder}
      fullWidth={fullWidth}
      size={size}
      type={type} // Can be 'date' or 'datetime-local'
      value={value}
      onChange={onChange}
      required={isRequired}
      InputLabelProps={{
        shrink: true, // Ensures the label shrinks for both date and datetime-local inputs
      }}
      {...props} // Spread other custom props like InputProps, including min/max dates
      sx={{
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#b99653", // Custom border color
          },
          "&:hover fieldset": {
            borderColor: "#ded0aa", // Border color on hover
          },
          "&.Mui-focused fieldset": {
            borderColor: "#563a2d", // Border color on focus
          },
        },
        "& .MuiInputLabel-root": {
          "&.Mui-focused": {
            color: "#563a2d", // Custom label color on focus
            background: "linear-gradient(90deg, #cca97cdb, #fcdb6a, #e2be6d)", // Gradient background on focus
            padding: "0 4px",
            fontWeight: "600",
          },
        },
        "& input[type=date], & input[type=datetime-local]": {
          "&::-webkit-clear-button, &::-webkit-inner-spin-button": {
            display: "none", // Hide clear and spin buttons
          },
          "&::-webkit-calendar-picker-indicator": {
            color: "#b99653", // Custom color for the calendar picker
          },
        },
      }}
    />
  );
}

export function CustomNumberField({
  label,
  value,
  onChange,
  isRequired,
  width,
  height,
  min_value, // Minimum value for the number input
  max_value, // Optional: Maximum value for the number input
  step_value, // Optional: Step value for the number input
  ...props
}) {
  CustomNumberField.propTypes = {
    label: PropTypes.any,
    value: PropTypes.any,
    onChange: PropTypes.any,
    isRequired: PropTypes.any,
    width: PropTypes.any,
    height: PropTypes.any,
    min_value: PropTypes.any,
    max_value: PropTypes.any,
    step_value: PropTypes.any,
  };
  return (
    <TextField
      label={label}
      variant="outlined"
      size="small"
      required={Boolean(isRequired)}
      value={value}
      onChange={onChange}
      type="number" // Set type as "number" explicitly
      {...props}
      inputProps={{
        ...(min_value && { min: min_value }), // Pass the min value if provided
        ...(max_value && { max: max_value }), // Pass the max value if provided
        ...(step_value && { step: step_value }), // Pass the step value if provided
      }}
      sx={{
        width: width ? width : null,
        height: height ? height : null,
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#b99653", // Custom border color
          },
          "&:hover fieldset": {
            borderColor: "#ded0aa", // Border color on hover
          },
          "&.Mui-focused fieldset": {
            borderColor: "#563a2d", // Border color on focus
          },
        },
        "& .MuiInputLabel-root": {
          "&.Mui-focused": {
            color: "#563a2d", // Custom label color on focus
            background: "linear-gradient(90deg, #cca97cdb, #fcdb6a, #e2be6d)", // Custom gradient background on focus
            padding: "0 4px",
            fontWeight: "600",
          },
        },
      }}
    />
  );
}

export const CustomFileInput = ({ label, accept, multiple, onChange }) => {
  CustomFileInput.propTypes = {
    label: PropTypes.any.isRequired,
    accept: PropTypes.any.isRequired,
    multiple: PropTypes.any.isRequired,
    onChange: PropTypes.any.isRequired,
  };
  const [selectedFiles, setSelectedFiles] = useState([]);
  const handleFileChange = (event) => {
    let files = Array.from(event.target.files); // Convert FileList to array
    const maxFiles = 4;
    const maxSize = 200 * 1024; // 200KB in bytes

    // Filter files that are larger than 200KB
    const validFiles = files.filter((file) => {
      if (file.size > maxSize) {
        toast.error(`${file.name} exceeds the 200KB size limit.`);
        return false;
      }
      return true;
    });

    const newSelectedFiles = [...validFiles, ...selectedFiles].slice(
      0,
      maxFiles
    ); // Limit to 4 files

    // Limit the number of files to 4
    if (validFiles.length > maxFiles) {
      validFiles.splice(maxFiles); // Limit the valid files array to 4
      toast.error("You can only add up to 4 image files.");
    }

    setSelectedFiles(newSelectedFiles); // Update local state with the valid files
    onChange(newSelectedFiles); // Pass the valid files to the parent component
  };

  const handleClearFiles = () => {
    setSelectedFiles([]); // Clear the selected files state
    onChange([]); // Pass the empty array to the parent component
  };

  return (
    <div>
      <label>{label}</label>
      <div className="flex gap-[8px] items-center flex-row !mt-[16px]">
        <Box
          display="flex"
          flexDirection="row"
          alignItems="flex-start"
          gap="12px"
        >
          <input
            type="file"
            accept={accept}
            multiple={multiple} // Allow multiple file selection
            style={{ display: "none" }}
            id="custom-file-input"
            onChange={handleFileChange}
          />
          <label htmlFor="custom-file-input" className="!pt-[0px]">
            <Button
              variant="outlined"
              component="span"
              className=" alternate-btn custom-btn  !border-[#b99653] !normal-case "
            >
              Select Files
            </Button>
          </label>
          {selectedFiles.length > 0 && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClearFiles}
              className="alternate-btn custom-btn !border-[#b99653] !normal-case "
            >
              Clear Files
            </Button>
          )}
        </Box>
      </div>
    </div>
  );
};

export function ATitle({ children, color }) {
  ATitle.propTypes = {
    children: PropTypes.any.isRequired,
    color: PropTypes.any.isRequired,
  };
  return (
    <Typography
      variant="h2"
      component="h1"
      gutterBottom
      sx={{ fontWeight: "700", color: color, fontSize: "32px" }}
    >
      {children}
    </Typography>
  );
}

export function AText({ children, color }) {
  AText.propTypes = {
    children: PropTypes.any.isRequired,
    color: PropTypes.any.isRequired,
  };
  return (
    <Typography
      variant="body2"
      component="h1"
      gutterBottom
      sx={{ fontWeight: "400", color: color, fontSize: "1rem" }}
    >
      {children}
    </Typography>
  );
}

export const PrettoSlider = styled(Slider)({
  color: "#64432f",
  height: 8,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&::before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "#64432f",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&::before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

export function CountdownTimer2({ endTime }) {
  CountdownTimer2.propTypes = {
    endTime: PropTypes.any.isRequired,
  };
  const calculateTimeLeft = (endTime) => {
    const difference = new Date(endTime) - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(endTime));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(endTime));
    }, 1000);

    return () => clearInterval(timer); // Cleanup interval on component unmount
  }, [endTime]);

  return (
    <div>
      {Object.keys(timeLeft).length > 0 ? (
        <div className="font-semibold  flex text-[#765032]">
          <span>{timeLeft.days}d&nbsp;</span>
          <span className="countdown flex items-center">
            <span style={{ "--value": timeLeft.hours }}></span>h&nbsp;
            <span style={{ "--value": timeLeft.minutes }}></span>m&nbsp;
            <span style={{ "--value": timeLeft.seconds }}></span>s&nbsp;
          </span>
        </div>
      ) : (
        <span>Time&apos;s up!</span>
      )}
    </div>
  );
}

export function CountdownTimer({ endTime }) {
  CountdownTimer.propTypes = {
    endTime: PropTypes.any.isRequired,
  };
  const calculateTimeLeft = (endTime) => {
    const difference = new Date(endTime) - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(endTime));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(endTime));
    }, 1000);

    return () => clearInterval(timer); // Cleanup interval on component unmount
  }, [endTime]);

  return (
    <div className="flex justify-between items-center w-full gap-[4px]">
      <div className="flex flex-col p-[2px] bg-[#ede7d4] rounded-[8px] text-neutral-content w-1/4 text-[#93693b]">
        {/* <span className="countdown font-mono text-xl justify-center">
          <span style={{ "--value": timeLeft.days }}></span>
        </span> */}
        <span className="leading-[16px]  text-[16px] font-bold justify-center text-center !py-0">
          {timeLeft.days}
        </span>
        <span className="text-sm text-center ">dd</span>
      </div>
      <div className="flex flex-col p-[2px] bg-[#ede7d4] rounded-[8px] text-neutral-content w-1/4 text-[#93693b]">
        <span className="countdown  text-[16px] font-bold justify-center">
          <span style={{ "--value": timeLeft.hours }}></span>
        </span>
        <span className="text-sm text-center">hh</span>
      </div>
      <div className="flex flex-col p-[2px] bg-[#ede7d4] rounded-[8px] text-neutral-content w-1/4 text-[#93693b]">
        <span className="countdown  text-[16px] font-bold justify-center">
          <span style={{ "--value": timeLeft.minutes }}></span>
        </span>
        <span className="text-sm text-center">mm</span>
      </div>
      <div className="flex flex-col p-[2px] bg-[#ede7d4] rounded-[8px] text-neutral-content w-1/4 text-[#93693b]">
        <span className="countdown  text-[16px] font-bold justify-center">
          <span style={{ "--value": timeLeft.seconds }}></span>
        </span>
        <span className="text-sm text-center">sec</span>
      </div>
    </div>
  );
}

export function CustomTextField({
  label,
  value,
  onChange,
  isRequired,
  rows,
  height,
  type, // Capture the type prop to check for date inputs
  ...props
}) {
  CustomTextField.propTypes = {
    label: PropTypes.any,
    value: PropTypes.any,
    onChange: PropTypes.any,
    isRequired: PropTypes.any,
    width: PropTypes.any,
    height: PropTypes.any,
    rows: PropTypes.any,
    type: PropTypes.any,
    step_value: PropTypes.any,
  };
  return (
    <TextField
      label={label}
      width="100%"
      variant="outlined"
      size="small"
      rows={rows}
      required={isRequired}
      value={value}
      height={height}
      onChange={onChange}
      type={type} // Pass the type prop
      {...props}
      InputLabelProps={{
        shrink: type === "date" || value ? true : undefined, // Force label to shrink for date inputs
      }}
      sx={{
        width: "100% !important",
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#b99653", // Custom border color
          },
          "&:hover fieldset": {
            borderColor: "#ded0aa", // Border color on hover
          },
          "&.Mui-focused fieldset": {
            borderColor: "#563a2d", // Border color on focus
          },
        },
        "& .MuiInputLabel-root": {
          "&.Mui-focused": {
            color: "#563a2d", // Custom label color on focus
            background: "linear-gradient(90deg, #cca97cdb, #fcdb6a, #e2be6d)", // Custom gradient background on focus
            padding: "0 4px", // Optional: padding to adjust for the label background
            fontWeight: "600",
          },
          ...(type === "date" && {
            transform: "translate(14px, -6px) scale(0.75)", // Adjust label positioning for date inputs
          }),
        },
        "& input[type=date]": {
          "&::-webkit-clear-button": {
            display: "none", // Hide clear button on Chrome
          },
          "&::-webkit-inner-spin-button": {
            display: "none", // Hide spin button on Chrome
          },
          "&::-webkit-calendar-picker-indicator": {
            color: "#b99653", // Custom color for the calendar icon
          },
        },
      }}
    />
  );
}

export function CustomCheckbox({ label, checked, onChange }) {
  CustomCheckbox.propTypes = {
    label: PropTypes.any.isRequired,
    checked: PropTypes.any.isRequired,
    onChange: PropTypes.any.isRequired,
  };
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          sx={{
            "&:hover": {
              background: "linear-gradient(90deg, #cca97cdb, #fcdb6a, #e2be6d)",
            },
            "&.Mui-checked": {
              color: "#b99653",
              "&:hover": {
                background: "white",
              },
            },
          }}
        />
      }
      label={label}
    />
  );
}

export function ASubHeading({ children }) {
  ASubHeading.propTypes = {
    children: PropTypes.any.isRequired,
  };
  return (
    <Typography
      variant="h2"
      component="h1"
      gutterBottom
      sx={{ fontWeight: "700", fontSize: "20px" }}
    >
      {children}
    </Typography>
  );
}

export function CustomSelect({ label, value, onChange, options }) {
  CustomSelect.propTypes = {
    label: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.any.isRequired,
    options: PropTypes.any.isRequired,
  };
  return (
    <FormControl size="small" sx={{ minWidth: 120, margin: "0px" }}>
      <InputLabel
        sx={{
          color: "#563a2d",
          "&.Mui-focused": {
            color: "#b99653",
          },
          // Custom label color on focus
          background: "linear-gradient(90deg, #cca97cdb, #fcdb6a, #e2be6d)", // Custom gradient background on focus
          fontWeight: "600",
          padding: "0 4px",
          borderRadius: "4px",
          zIndex: 1,
        }}
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label={label}
        size="small"
        sx={{
          padding: "1.5px 0",
          "& .MuiOutlinedInput-root": {
            padding: "0", // Remove default padding to ensure small size
            height: "8px !important", // Set height to match small size
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#b99653", // Custom border color
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ded0aa", // Border color on hover
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#563a2d", // Border color on focus
          },
          "& .MuiSelect-icon": {
            color: "#b99653", // Custom color for dropdown icon
          },
          "& .MuiSelect-select": {
            backgroundColor: "transparent", // Transparent background
            color: "#b99653", // Custom text color
            padding: "7px !important", // Adjust padding to fit small size
            minHeight: "6px !important", // Ensure minimum height matches small size
            display: "flex",
            alignItems: "center", // Center align text and icon
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: "#cab27a", // Background color of the menu
              color: "#ffffff", // Text color in the menu
              "& .MuiMenuItem-root": {
                color: "#ffffff",
              },
              "& .MuiMenuItem-root.Mui-selected": {
                backgroundColor: "#ab8547",
              },
              "& .MuiMenuItem-root.Mui-selected:hover": {
                backgroundColor: "#93693b",
              },
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export function CustomButtonGroup({ buttons, filterType }) {
  CustomButtonGroup.propTypes = {
    buttons: PropTypes.any.isRequired,
    filterType: PropTypes.any.isRequired,
  };
  return (
    <ButtonGroup
      variant="contained"
      aria-label="button group"
      sx={{
        width: "fit-content",
        "& > span": {
          zIndex: 3,
          background:
            "linear-gradient(to top, transparent, rgba(255 255 255 / 0.6), transparent)",
        },
      }}
    >
      {buttons.map((button, index) => (
        <React.Fragment key={button.label}>
          <Button
            onClick={button.onClick}
            sx={{
              padding: "6px 12px",
              backgroundColor:
                filterType === button.value ? "#B99653" : "#f8f6ee",
              color: filterType === button.value ? "white" : "#333",
              "&:hover": {
                backgroundColor:
                  filterType === button.value ? "#93693b" : "#ede7d4",
                color: filterType === button.value ? "white" : "#333",
              },
              "&:first-of-type": {
                borderRight: "1px solid #B99653",
              },
              // Style for middle buttons
              "&:not(:first-of-type):not(:last-of-type)": {
                borderRight: "1px solid #B99653",
              },
            }}
          >
            {button.label}
          </Button>
          {index < buttons.length - 1 && (
            <Divider
              orientation="vertical"
              flexItem
              sx={{ borderColor: "#B99653" }}
            />
          )}
        </React.Fragment>
      ))}
    </ButtonGroup>
  );
}

export const CustomDataGrid = ({ rows, columns, customSettings = {} }) => {
  CustomDataGrid.propTypes = {
    rows: PropTypes.any.isRequired,
    columns: PropTypes.any.isRequired,
    customSettings: PropTypes.any.isRequired,
  };
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      {...customSettings} // spread any additional settings here
      sx={{
        "& .MuiDataGrid-root": {
          fontFamily: "Open Sans !important", // Set the font
        },
        "& .MuiDataGrid-columnHeader": {
          fontWeight: "bold", // Optional: make headers bold
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          fontFamily: "Open Sans",
        },
        "& .MuiDataGrid-row ": { fontFamily: "Open Sans" },
        "& .MuiDataGrid-container--top [role=row]": {
          fontFamily: "Open Sans",
          background: "#b99653",
          color: "white",
          fontSize: "1.2rem",
        },
        "& .MuiDataGrid-container--bpttom [role=row]": {
          fontFamily: "Open Sans",
          background: "#b99653",
          color: "white",
        },
        "& .MuiDataGrid-footerContainer": {
          background: "#B99653",
          color: "white",
          fontSize: "1.2rem",
        },
        "& .MuiTablePagination-root": {
          color: "white",
          fontSize: "1.2rem",
        },
        "& .MuiTablePagination-caption": {
          color: "white",
          fontSize: "1.2rem",
        },
        "& .MuiTablePagination-selectIcon": {
          color: "white",
          fontSize: "1.2rem",
        },
        "& .MuiTablePagination-actions button": {
          color: "white",
        },
        "& .MuiTablePagination-toolbar": {
          color: "white",
        },
        "& .MuiSvgIcon-root": {
          color: "white",
        },
        // Add more custom styles here as needed
      }}
    />
  );
};

export default Elements;
